export default {
  finalAllocation: {
    en: "Your final allocation for this Tier",
    ja: "このランクの最終的な割り当て"
  }
}
